module.exports = __webpack_public_path__ + "media/images/safely_logo-eb2a095450f6d38e3bb02bb2a565fc2d.png";